import { ObjectContainerClientDataT, ObjectTypePropertyCollectionItemT } from 'bovaljaren-models';

export const objectTypePropertySorting = (a: ObjectTypePropertyCollectionItemT | ObjectContainerClientDataT, b: ObjectTypePropertyCollectionItemT | ObjectContainerClientDataT): number => a.sortOrder > b.sortOrder ? 1 : -1;


export const objectTypeProperyFiltering = (oT: ObjectTypePropertyCollectionItemT | ObjectContainerClientDataT): boolean => {
    if (oT.type === 'description' || oT.type === 'richDescription' || oT.type === 'externalUrl')
        return false;

    return true;
};